import { SimulateMultiResultsPopUpComponent } from './simulate-multi-results-pop-up/simulate-multi-results-pop-up/simulate-multi-results-pop-up.component';
import { Title } from '@angular/platform-browser';
import { WindowService } from './../../../services/window.service';
import { Component, OnInit, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { TaskDataFilter } from '../../stock/stock.service';
import { ActivatedRoute, Data } from '@angular/router';
import { ShareDataService } from 'src/app/services/share-data.service';
import { TaskService } from '../../task/task.service';
import { HelpService } from '../../help/help.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { DxDataGridComponent } from 'devextreme-angular';
import { firstValueFrom } from 'rxjs';
import { UtilsService } from 'src/app/services/utils.service';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { InfoBoxService } from 'src/app/services/info-box.service';
import { TableDataOperator } from 'src/app/operators/table-data.operator';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { DxDataGridBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import { SimulateMultiResult } from './models/simulate-multi-result.model';

@Component({
    selector: 'app-simulate-multi',
    templateUrl: './simulate-multi.component.html',
    styleUrls: ['./simulate-multi.component.scss'],
    standalone: false
})
export class SimulateMultiComponent implements OnInit {

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetEsoSimulateMultiGridData,
				selectionSetId: SelectionSetId.EsoSimulateMultiFilters,
			}
		)
	);

	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	@ViewChild('dataGrid', { static: false })
	public dataGrid: DxDataGridComponent;

	private readonly _activatedRoute: ActivatedRoute = inject(ActivatedRoute);

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			),
			new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dataGrid
			),
		];

		return routeData;
	}

	public tableDataOperator: TableDataOperator = new TableDataOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetEsoSimulateMultiGridData,
				selectionSetId: SelectionSetId.EsoSimulateMultiGrid
			}
		)
	);

	showPopup = false;

	selectedProducts: string[] = [];

	compactMode = false;

	public simulateMultiResultsPopUpVisible: boolean = false;

	@ViewChild('simulateMultiResultsPopUp', { static: true })
	public simulateMultiResultsPopUp: SimulateMultiResultsPopUpComponent;

	public onSimulationInitiated(evt: any): void {
		//console.error(this.selectedProducts.length);
		this.simulateMultiResultsPopUp.simulateMultiResultsInProgress.push(new SimulateMultiResult());
		console.log(this.simulateMultiResultsPopUp);
		this.initializeSimulationsInProgress();
	}

	public onSimulationTrainingInitiated(evt: any): void {
	}

	public async initializeSimulationsInProgress(): Promise<void> {
		console.log("initializeSimulationsInProgress");

		const simulateMultiResults = this.simulateMultiResultsPopUp.initializeSimulateMultiResultsDataGrid();
		const simulateMultiTrainingResults = this.simulateMultiResultsPopUp.initializeSimulateMultiTrainingResultsDataGrid();

		await simulateMultiResults;
		await simulateMultiTrainingResults;
	}

	taskFilterData: TaskDataFilter[];

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.tableDataOperator.load(
							{
								showLoadingIndicator: true,
							}
						);
					}
				}
			}
		);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const filter = evt.component.getCombinedFilter();

		if (filter) {
			this.dxDataGridHasActiveFilters = true;
		} else {
			this.dxDataGridHasActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-simulate-multi-scoped', JSON.stringify(this.dataGrid.instance.state()));
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	public dxDataGridHasActiveFilters: boolean = false;

	public changeActiveFiltersStatus() {
		if (this.dxDataGridHasActiveFilters) {
			this.dxDataGridHasActiveFilters = !this.dxDataGridHasActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
		}
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "gridActions",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: "before",
			template: "simulationActions",
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}
	);
	}

	selectionChanged(e) {
		console.log("selectionChanged - event:", e);

		this.selectedProducts = [];

		e.selectedRowsData.forEach(
			element => {
				if (!this.selectedProducts.includes(element.ProductId)) {
					this.selectedProducts.push(element.ProductId);
				}
			}
		);

		console.log("selectionChanged -> this.selectedProducts", this.selectedProducts);
	}

	changePopupStatus() {
		if (this.selectedProducts.length > 0) {
			this.showPopup = !this.showPopup;
		} else {
			this._infoBoxService.show(
				{
					message: 'Please, select at least 1 product.',
					title: 'Information',
					displayTimeMs: -1
				}
			);
		}
	}

	public changeSimulateMultiResultsPopUpStatus() {
		this.simulateMultiResultsPopUpVisible = !this.simulateMultiResultsPopUpVisible;
	}

	goToDeepDive(data: any) {
		if (!data.ProductId) {
			return;
		}

		this._windowService.openInNewPage("/eso/deep-dive", {
			productId: data.ProductId,
		});
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;
	}

	public onHelpButtonClicked(settingName: string) {
		this._helpService.openHelpPage(settingName);
	}

	/* Export Option */
	public exportEnabled: boolean = false;
	IsExportListEnable = false;

	GetSettingsData() {
		this._fileExportService.WebSettings("EnableExportEsoSimulateMulti").subscribe(resultFilename => {
			this.exportEnabled = (resultFilename.value.toLowerCase() == "yes");
		}, err => {
			console.log(err);
		});
		this._fileExportService.WebSettings("EnableExportEsOEsoSimulatelist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes");
		}, err => {
			console.log(err, "err");
		});
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew?.columns != null && statenew.columns.length > 0){
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
	}

	//scope table
	fitScopeTableToPage = false;
	changeFitToScopePageStatus() {
		this.fitScopeTableToPage = !this.fitScopeTableToPage;
		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	constructor(
		private readonly _titleService: Title,

		private readonly _windowService: WindowService,
		private readonly _helpService: HelpService,
		private readonly _shareDataService: ShareDataService,
		private readonly _routeMap: ActivatedRoute,
		private readonly _taskServiceNew: TaskService,
		private readonly _fileExportService: FileExportService,
		private readonly _infoBoxService: InfoBoxService,

		public changeDetectorRef: ChangeDetectorRef,
	) { }

	async ngOnInit() {
		this._titleService.setTitle("Eso Simulate Multi");

		this._routeMap.paramMap.subscribe(
			() => {
				const value = this._routeMap.snapshot.queryParamMap.get("taskid");

				if (value) {


					this._taskServiceNew.SelectTaskFilterValues(value).subscribe(
						(data) => {
							this.taskFilterData = data;
							this.taskFilterData.forEach(
								(_) => {

								}
							);

							this.loadPageData();

						}
					);
				}
			}
		);

		await this.initializeBookmarks();

		this.loadPageData();

		this.GetSettingsData();
		this.initializeSimulationsInProgress();

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			async (selection) => {
				this._shareDataService.CleanData();
				this._shareDataService.filterOptionOverview = selection.output;

				(await this.pageFiltersOperator.getObservable(
					{
						showLoadingIndicator: true,
					}
				)).subscribe(
					{
						next: (_) => {
							this.tableDataOperator.load(
								{
									showLoadingIndicator: true
								}
							);
						}
					}
				);
				this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this._shareDataService.filterOptionOverview.filters);				
			}
		);
	}
	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	}
}
